module.exports = __webpack_public_path__ + "static/media/s4hana.db29a9dd.png";